export enum Countries {
  Australia = 'AUS',
  NewZealand = 'NZL',
  Hongkong = 'HKG',
  Singapore = 'SGP',
  Indonesia = 'IDN',
  Japan = 'JPN',
  India = 'IND',
  China = 'CHN',
  Korea = 'KOR',
  Taiwan = 'TWN',
  Thailand = 'THA',
  Philippines = 'PHL',
  Vietnam = 'VNM',
  UnitedStates = 'USA',
}
